module.exports = __webpack_public_path__ + "img/bg-upload.48eacf5c.png";